export default __webpack_public_path__ + "static/media/email_check.20fe7132.svg";